import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

class PicNewsAndVideo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        type: PropTypes.string,
    };

    render() {
        const { content, type } = this.props;

        if (content && content.length === 0) return <div />;

        return (
            <div className={styles.box}>
                <div className={styles.title}>
                    <h4>{type === 'pic' ? '图片新闻' : '视频'}</h4>
                </div>
                <ul>
                    {content.map((item, index) => (
                        <li key={index} className="clearfix">
                            <a href={item.url} target="_blank" title={item.title}>
                                <img src={item.img} alt={item.title} width="165" height="100" />
                                <p>{item.title}</p>
                                <div className={styles.play_btn} />
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(PicNewsAndVideo);
